(function() {
    'use strict';

    angular.module('app.periodos', []);
})();
